module.exports = __webpack_public_path__ + "resources/img/img_cloud_architecture_02.91e559d5b2a7b0f73483f108d796ef59.png";